import * as ContentLinkNS from '../Models/ContentLink';
import StringUtils from '../Util/StringUtils';

export const ContentLink = ContentLinkNS.ContentLinkService
export const String = StringUtils;